// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xQi4","colBig":"styles_colBig__29NCO","colSmall":"styles_colSmall__3cunr"};